import {
  GlobalSearchEntityFilter,
  GlobalSearchRegistryItem,
  GlobalSearchState,
  IGlobalSearchRegistry
} from '../../interfaces/global-search';

function noFiltersApplied(state: GlobalSearchState) {
  return state.filters.entity.length === 0;
}

function isEntityFilterApplied(state: GlobalSearchState, entity: string) {
  return state.filters.entity.includes(entity);
}

export function canShowGlobalSearchEntity(
  state: GlobalSearchState,
  entity: string
) {
  const isLoading = state.items[entity].loadingData;
  const isFilteredDataAvailable = state.items[entity].filteredEntities.length > 0;
  const anyFilterApplied = noFiltersApplied(state) || isEntityFilterApplied(state, entity);

  return (isLoading && anyFilterApplied) || (anyFilterApplied && isFilteredDataAvailable);
}

export function getGlobalSearchUIRenderingData(state: GlobalSearchState) {
  const itemKeys = Object.keys(state.items);

  const totalFilteredEntities = itemKeys.reduce(
    (acc, key) => acc + state.items[key].filteredEntities.length,
    0
  );
  const hasSearchResults = totalFilteredEntities > 0;

  const loading = itemKeys.some((key) => state.items[key].loadingData);

  const showBody = loading || Boolean(state.filters.search) || hasSearchResults;

  const entitiesWithFilterApplied = state.filters.entity.reduce((acc, curr) => acc + state.items[curr].filteredEntities.length, 0);

  const showNoResultFound =
    !loading && (noFiltersApplied(state) ? !hasSearchResults : entitiesWithFilterApplied === 0);


  return {
    loadingData: loading,
    showBody,
    showNoResultFound,
    showEntities: !showNoResultFound
  };
}

interface GlobalSearchInitialStateReturnType {
  initialState: GlobalSearchState['items'];
  filterChips: GlobalSearchEntityFilter[];
  filterSensitiveCBs: { cb: GlobalSearchRegistryItem['dataResolver'], entity: string; }[];
  filterInsensitiveCBs: { cb: GlobalSearchRegistryItem['dataResolver'], entity: string; }[];
}

export function getGlobalSearchInitialState(
  registry: IGlobalSearchRegistry
): GlobalSearchInitialStateReturnType {
  const entities = Object.keys(registry);

  const renderedEntities = entities.filter((entity) => !registry[entity].doNotRender?.());

  return renderedEntities.reduce(
    (acc, key) => ({
      ...acc,
      initialState: {
        ...acc.initialState,
        [key]: {
          entities: [],
          filteredEntities: [],
          loadingData: false,
          metaData: registry[key]
        }
      },
      filterChips: [...acc.filterChips, ...registry[key].filters],
      filterSensitiveCBs: [
        ...acc.filterSensitiveCBs,
        ...(!registry[key].inMemoryFiltering ? [{ cb: registry[key].dataResolver, entity: key }] : [])
      ],
      filterInsensitiveCBs: [
        ...acc.filterInsensitiveCBs,
        ...(registry[key].inMemoryFiltering ? [{ cb: registry[key].dataResolver, entity: key }] : [])
      ]
    }),
    {
      initialState: {},
      filterChips: [],
      filterSensitiveCBs: [],
      filterInsensitiveCBs: []
    } as GlobalSearchInitialStateReturnType
  );
}
